import { format, formatDistance, differenceInDays } from "date-fns";
import React, {useEffect, useState,useRef} from "react";
import { Link } from "gatsby";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import BlockContent from "./block-content";
import BlockTOC from "./block-table-of-content";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const callbackFunction = (entries) => {
        const [entry] = entries;
        setIsIntersecting(entry.isIntersecting);
    }


    useEffect(() => {
        const observer = new IntersectionObserver(callbackFunction);
        observer.observe(ref.current);
        return () => {
            observer.disconnect();
        };
    }, [ref]);
    return isIntersecting;
}

function Story(props) {
  const { _rawBody, title, subtitle, entity, mainImage, publishedAt, language } = props;
    const refArticleContent = useRef(null);
    const isInViewport1 = useIsInViewport(refArticleContent);


  function goTop(){window.scrollTo({top: 0, behavior: 'smooth'})}

  let goTopBtnClass = "hiddenElAnimated";

  if(isInViewport1){
      goTopBtnClass = "visibleElAnimated";
  }


  
  return (
      <article id="article" className="resources" >
        {language && language === 'es' && 
        <div className="resources-context-menu">
          <ul>
            <li><Link to="/es/blog/">Todas las Historias</Link></li>
            <li className={entity === 'tutoriales' ? "selected" : ""}><Link to="/es/blog/tutoriales/">Aprende con Crema</Link></li>
            <li className={entity === 'tips' ? "selected" : ""}><Link to="/es/blog/tips/">Tips</Link></li>
            <li className={entity === 'comunidad' ? "selected" : ""}><Link to="/es/blog/comunidad/">Comunidad</Link></li>
            <li className={entity === 'compania' ? "selected" : ""}><Link to="/es/blog/compania/">Compañia</Link></li>
              <li className={entity === 'herramientas' ? "selected" : ""}><Link to="/es/blog/herramientas/">Herramientas</Link></li>
          </ul>
        </div>
        }
        {language && language === 'en' && 
        <div className="resources-context-menu">
          <ul>
            <li><Link to="/en/blog/">All the stories</Link></li>
            <li className={entity === 'how-to' ? "selected" : ""}><Link to="/en/blog/how-to/">Learn with Crema</Link></li>
            <li className={entity === 'tips' ? "selected" : ""}><Link to="/en/blog/tips/">Tips</Link></li>
            <li className={entity === 'community' ? "selected" : ""}><Link to="/en/blog/community/">Community</Link></li>
            <li className={entity === 'company' ? "selected" : ""}><Link to="/en/blog/company/">Company</Link></li>
          </ul>
        </div>
        }
        <div className="content">
          <div className="top">
            <div className="entity"><span>{entity}</span></div>
            <div className="title"><h1>{title}</h1></div>
            <div className="subtitle"><h2>{subtitle}</h2></div>
          </div>
        </div>
        {props.mainImage && mainImage.asset && (
          <div id="main-img" className="main-img">
            <img src={imageUrlFor(buildImageObj(mainImage)).width(1200).height(Math.floor((9 / 16) * 1200)).fit("crop").url()} alt={mainImage.alt} width="auto" height="auto" loading="eager"/>
          </div>
        )}
        <div className="content">
        {props.writer.image &&
          <div className="writer">
            <div className="pp">
              <img src={imageUrlFor(buildImageObj(props.writer.image)).width(120).height(120).fit("crop").url()} alt={"Foto de perfil de "+props.writer.name} width="auto" height="auto" loading="eager"/>
            </div>
            <div className="data">
              <span>{props.writer.name}&nbsp;&nbsp;</span><span>
                {differenceInDays(new Date(publishedAt), new Date()) > 3
                    ? formatDistance(new Date(publishedAt), new Date())
                    : format(new Date(publishedAt), "MMMM do yyyy")}
              </span>
            </div>
          </div>
        }
          <div>
            <div className="title-table-contents">Table of contents</div>
            <div className="table-of-content">{_rawBody && <BlockTOC blocks={_rawBody || []} />}</div>
          </div>
          <div className='article-content' ref={refArticleContent}>
            {_rawBody && <BlockContent blocks={_rawBody || []} />}
          </div>
        </div>

              <div id="up-wrap" >
                  <div id="up-button" className={goTopBtnClass} onClick={goTop}>
                      <span>Up</span>
                  </div>
              </div>

      </article>
  );
}

export default Story;